import React from 'react';
import styled from 'styled-components';
import {device} from '../../styled/device';

export const overlayStyle: React.CSSProperties = {
  background: 'rgba(16,16,16,0.3)',
  overflowY: 'auto',
  paddingBottom: 91,
  transition: 'transform 1s',
};

export const contentStyle: React.CSSProperties = {
  width: 'auto',
  padding: 50,
  border: 'none',
  borderRadius: 16,
  textAlign: 'center',
  marginTop: 130,
  position: 'relative',
  transition: 'transform 1s',
};

type WrapperProps = {
  zIndex?: number | string;
};

export const Wrapper = styled.div<WrapperProps>`
  @keyframes anvil {
    0% {
      transform: scale(1) translateY(0px);
      opacity: 0;
      box-shadow: 0 0 0 rgba(241, 241, 241, 0);
    }
    1% {
      transform: scale(0.96) translateY(10px);
      opacity: 0;
      box-shadow: 0 0 0 rgba(241, 241, 241, 0);
    }
    100% {
      transform: scale(1) translateY(0px);
      opacity: 1;
      box-shadow: 0 0 500px rgba(241, 241, 241, 0);
    }
  }

  @keyframes overlay {
    0% {
      opacity: 0;
      box-shadow: 0 0 0 rgba(241, 241, 241, 0);
    }
    100% {
      opacity: 1;
      box-shadow: 0 0 500px rgba(241, 241, 241, 0);
    }
  }

  & .popup-overlay {
    z-index: ${props => props.zIndex || 999} !important;
    transition: all ease-in-out 1000ms;
    -webkit-animation: overlay 0.4s forwards;

    @media (max-width: ${device.mobileXL}) {
      padding: 20px;
    }
  }
  &&& .popup-content {
    height: auto;
    width: auto;
    max-width: 500px;
    min-width: 306px;
    min-height: 365px;
    -webkit-animation: anvil 0.3s forwards;

    @media (max-width: ${device.mobileXL}) {
      min-width: auto;
      width: 100% !important;
      padding: 40px 20px !important;
    }
  }

  @media (max-width: ${device.mobileXL}) {
    .popup-overlay {
      padding: 20px;
    }

    .popup-content {
      width: 100% !important;
      padding: 40px 20px !important;
    }
  }
`;

export const IconWrapper = styled.div`
  text-align: center;
  user-select: none;

  &.icon-modal {
    height: 84px;
    width: 84px;
  }
`;

export const Title = styled.div`
  text-align: center;
  font-family: 'Poppins', sans-serif;
  font-size: 24px;
  padding: 0 25px;
  color: #161643;
  cursor: default;
  margin: 20px auto 0;
`;

export const Text = styled.div`
  font-family: 'Poppins', sans-serif;
  color: #161643;
  font-size: 18px;
  /* max-width: 254px; */
  margin: 10px auto 47px;
  box-sizing: border-box;
  text-align: center;
  cursor: default;

  & > b {
    font-family: 'Poppins', sans-serif;
    font-weight: normal;
  }
`;

export const CloseButton = styled.div`
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px;
  top: -16px;
  right: -16px;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background-color: white;
  box-shadow: 0 8px 16px #0f0f0f1a;
  cursor: pointer;

  & > img {
    height: 15px;
    vertical-align: middle;
    transition: transform 0.2s;
  }

  &:hover {
    img {
      transform: rotate(0.25turn);
    }
  }
`;
